import Auth from '@aws-amplify/auth';
import { Formik, FormikProps } from 'formik';
import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { FORM_ERROR } from 'src/appConfig/constanst';
import { Button, Form, InputPassword, Text, View } from 'src/components/common';
import { Modal } from 'src/components/Modal';
import { authActions } from 'src/redux/authRedux';
import { ChangePasswordPayload } from 'src/redux/authRedux/types';
import { ErrorService, Toastify, Yup } from 'src/services';
import { IAppState } from 'src/store';
// import { isValidPassword } from 'src/validations';
import './styles.scss';

type FormValue = {
  currentPassword: string;
  newPassword: string;
};

const ChangePassword: React.FC<Props> = ({ onClose, onChangePassword }) => {
  const formRef = useRef<FormikProps<FormValue>>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const INTIAL = {
    currentPassword: '',
    newPassword: '',
  };

  const handleSubmitForm = (values: FormValue) => {
    setIsSubmitting(true);

    Auth.currentAuthenticatedUser().then(user => {
      const payload: ChangePasswordPayload = { ...values, user };
      onChangePassword(payload, changePasswordSuccess, changePasswordError);
    });
  };

  const changePasswordSuccess = (res: AuthError) => {
    Toastify.success('Your password has been changed!');
    setIsSubmitting(false);
    onClose();
  };

  const changePasswordError = (error: any) => {
    setIsSubmitting(false);
    if (formRef.current)
      switch (error.code) {
        case 'NotAuthorizedException':
          return formRef.current.setErrors({ currentPassword: ErrorService.MESSAGES.incorrectPassword });

        case 'InvalidPasswordException':
          return formRef.current.setErrors({ newPassword: error.message });

        case 'LimitExceededException':
          return formRef.current.setErrors({ newPassword: error.message, currentPassword: ' ' });

        default:
          return ErrorService.handler(error);
      }
  };

  const FormSchema = Yup.object().shape({
    currentPassword: Yup.string().required(FORM_ERROR.RequiredField),
    newPassword: Yup.string().password().required(FORM_ERROR.RequiredField),
    // .test('is-valid-password', PASSWORD_VALIDATION_ERROR_MESSAGE, value => isValidPassword(value ?? '')),
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal onModalClosed={handleClose} allowCloseByEsc={false}>
      <Text variant="title" size={24} className="mb-16">
        Change Password
      </Text>

      <View className="ctn-change-password">
        <Formik initialValues={INTIAL} onSubmit={handleSubmitForm} validationSchema={FormSchema} innerRef={formRef}>
          {({ errors, touched, getFieldProps, handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit} autoComplete="off" className="ctn-change-password__form">
                <InputPassword
                  label="Current Password"
                  placeholder="Password"
                  errorMessage={touched.currentPassword ? errors.currentPassword : ''}
                  containerClassName="mb-16"
                  {...getFieldProps('currentPassword')}
                />
                <InputPassword
                  label="New Password"
                  placeholder="New Password"
                  errorMessage={touched.newPassword ? errors.newPassword : ''}
                  containerClassName="mb-16"
                  {...getFieldProps('newPassword')}
                />

                <View isRow justify="center" className="mt-32">
                  <Button type="submit" variant="secondary" isLoading={isSubmitting}>
                    Submit
                  </Button>
                </View>
              </Form>
            );
          }}
        </Formik>
      </View>
    </Modal>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose: () => void;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  onChangePassword: authActions.changePassword,
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
